import { render, staticRenderFns } from "./MlbGameDaySection.vue?vue&type=template&id=27b22f51&scoped=true"
import script from "./MlbGameDaySection.vue?vue&type=script&lang=js"
export * from "./MlbGameDaySection.vue?vue&type=script&lang=js"
import style0 from "./MlbGameDaySection.vue?vue&type=style&index=0&id=27b22f51&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27b22f51",
  null
  
)

export default component.exports